module.exports = __webpack_public_path__ + "static/media/stage_fright_noStars_s_s.b4bf1eec.jpg";